import { render, staticRenderFns } from "./PublicModule.vue?vue&type=template&id=638e184c&scoped=true"
import script from "./PublicModule.vue?vue&type=script&lang=js"
export * from "./PublicModule.vue?vue&type=script&lang=js"
import style0 from "./PublicModule.vue?vue&type=style&index=0&id=638e184c&prod&lang=scss&scoped=true"
import style1 from "./PublicModule.vue?vue&type=style&index=1&id=638e184c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638e184c",
  null
  
)

export default component.exports